// extracted by mini-css-extract-plugin
module.exports = {"MoneyInput":"MoneyInput_MoneyInput__3AFx4"};